import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationCircle,
  faInfoCircle,
  faLightbulb,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";

const RateLimitAlert = ({ limit = 180, remaining = 0, onClose }) => {

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full mx-4 overflow-hidden border border-gray-100">
        {/* Header */}
        <div className="bg-red-50 p-4 flex items-center justify-between rounded-t-2xl">
          <div className="flex items-center space-x-3">
            <FontAwesomeIcon
              icon={faExclamationCircle}
              className="text-red-600 text-2xl"
            />
            <h3 className="text-xl font-semibold text-red-600">
              Rate Limit Reached
            </h3>
          </div>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 transition-colors"
          >
            <FontAwesomeIcon icon={faTimes} className="text-lg" />
          </button>
        </div>

        {/* Body */}
        <div className="p-6">
          <p className="text-gray-700 mb-4">
            Hi there! It looks like you've reached the maximum number of requests
            allowed within a certain time frame.
          </p>

          {/* Details */}
          <div className="bg-gray-50 p-4 rounded-xl mb-4 border border-gray-200">
            <div className="flex items-center space-x-3 mb-3">
              <FontAwesomeIcon
                icon={faInfoCircle}
                className="text-blue-500 text-lg"
              />
              <h4 className="text-sm font-medium text-gray-800">Details</h4>
            </div>
            <div className="space-y-2">
              <p className="text-sm text-gray-700">
                <span className="font-medium">Allowed Requests:</span> {limit}
              </p>
              <p className="text-sm text-gray-700">
                <span className="font-medium">Remaining Requests:</span>{" "}
                {remaining}
              </p>
            </div>
          </div>

          {/* Tips */}
          <div className="bg-yellow-50 p-4 rounded-xl mb-4 border border-yellow-200">
            <div className="flex items-center space-x-3 mb-3">
              <FontAwesomeIcon
                icon={faLightbulb}
                className="text-yellow-600 text-lg"
              />
              <h4 className="text-sm font-medium text-gray-800">Tips</h4>
            </div>
            <p className="text-sm text-gray-700">
              To continue using the service, please wait a while before making
              another request. This helps us ensure fair usage for all users and
              maintain the stability of the system.
            </p>
            <p className="text-sm text-gray-700 mt-2">
              <strong>Tip:</strong> Slow down your requests to avoid hitting the
              limit again. If you need to make frequent requests, consider
              spacing them out over time.
            </p>
          </div>

          {/* Action Button */}
          <button
            onClick={onClose}
            className="w-full bg-red-600 text-white py-2 px-4 rounded-xl hover:bg-red-700 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default RateLimitAlert;